import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import Spinner from "../../components/spinner";
import { useToaster } from "../../context/ToasterContext";
import "../../styles/payment-webview.scss";
import EqualSplitIcon from "../../assets/icons/equal.png";
import UnequalSplitIcon from "../../assets/icons/not-equal.png";
import { useShopDetailsContext } from '../../context/ShopDetailsContext';
import { fetchShopDetailsByShopLink, getMinimumAmountForCurrency } from "../../utils/global";
import PoweredByComponent from "../../webview-components/powered-by";
import QrScanner from 'qr-scanner';

const Homepage = () => {
  useEffect(() => {
    document.title = "Home - SuperCheckout";
  }, []);

  const { toaster } = useToaster();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { setShopDetailsContext } = useShopDetailsContext();

  const videoRef = useRef(null);
  const qrScannerRef = useRef(null);

  useEffect(() => {
    setShopDetailsContext(prev => ({
      ...prev,
      user_image: "/supercheckout-logo-icon-512-512.png",
      shop_name: "SuperCheckout"
    }));

    QrScanner.WORKER_PATH = '/qr-scanner-worker.min.js';
    // Make sure you have this file served! (from node_modules or copy it yourself)

    const videoElem = videoRef.current;

    qrScannerRef.current = new QrScanner(
      videoElem,
      result => {
        console.log('Decoded QR code:', result.data);

        if(result.data && result.data !== null){
          if(result.data.indexOf('http://localhost:3000/') > -1 || result.data.indexOf(window.location.origin) > -1){
            window.location.href = result.data;
          }
          else{
            //toaster.error("Sorry! This QR code is not supported by us.");
          }
        }
      },
      {
        preferredCamera: 'environment', // Back camera
        highlightScanRegion: true,
        highlightCodeOutline: true,
      }
    );

    qrScannerRef.current.start();

    return () => {
      qrScannerRef.current?.stop();
    };
  }, []);

  return (
    <>
      <div className="home-page-wrapper">
        {loading && <Spinner />}

        {!loading && 
          <>
            <div>
              <div className="qrScannerContainer">
                <video
                  ref={videoRef}
                  muted
                  playsInline
                />
              </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

export default Homepage;
